import { PALETTE, SIZES } from '../../../../constants';
import { MediaQueryStyleSheet } from 'react-native-responsive';
import { MQ_TABLET, MQ_PHONE } from "../../../../constants";

export default MediaQueryStyleSheet.create({
  currencyStyle: {
    fontSize: 20,
  },
  decimalStyle: {
    fontSize: 14,
  },
  netIncomeLabel: {
    marginBottom: 15,
  },
  align: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center',
  },
  value: {
    color: 'white',
    letterSpacing: 0.21,
  },
  noData: {
    marginLeft: 1,
    height: 19,
    width: 17,
    marginBottom: 4,
    borderBottomColor: PALETTE.primaryStrokeLine,
    borderBottomWidth: 1,
    backgroundColor: 'transparent',
  },
  arrow: {
    justifyContent: 'center',
    marginLeft: 10,
  },
  netIncomeValueArrowClass: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'flex-start',
  }
},
  {
    [MQ_PHONE]: {
      currencyStyle: {
        fontSize: 14,
      },
      align: {
        textAlign: 'center',
      },
      netIncomeLabel: {
        marginBottom: 0,
      },
      justify: {
        justifyContent: 'center',
        marginTop: 23,
      },
    }
  });
